import dayjs from 'dayjs';

export const getRemainingTime = (timeStamp) => {
  const timeStampDayjs = dayjs(timeStamp); // reprensenting the moment of time which is this timeStamp that we pass in our function
  const nowDayjs = dayjs(); // represents the current moment of time

  // to check if the timeStamp is old i.e. in the past then to display 00:00:00:00
  if (timeStampDayjs.isBefore(nowDayjs)) {
    return {
      seconds: '00',
      minutes: '00',
      hours: '00',
      days: '00',
    };
  }

  return {
    seconds: getRemainingSeconds(nowDayjs, timeStampDayjs),
    minutes: getRemainingMinutes(nowDayjs, timeStampDayjs),
    hours: getRemainingHours(nowDayjs, timeStampDayjs),
    days: getRemainingDays(nowDayjs, timeStampDayjs),

    // seconds: '12',
    // minutes: '12',
    // hours: '15',
    // days: '31',
  };
};

const getRemainingSeconds = (nowDayjs, timeStampDayjs) => {
  const seconds = timeStampDayjs.diff(nowDayjs, 'seconds') % 60;
  return padWithZeros(seconds, 2);
}; // this will get the current moment of time and another dayjs object reprensenting the end of countDown

const getRemainingMinutes = (nowDayjs, timeStampDayjs) => {
  const minutes = timeStampDayjs.diff(nowDayjs, 'minutes') % 60;
  return padWithZeros(minutes, 2);
}; // this will get the current moment of time and another dayjs object reprensenting the end of countDown

const getRemainingHours = (nowDayjs, timeStampDayjs) => {
  const hours = timeStampDayjs.diff(nowDayjs, 'hours') % 24;
  return padWithZeros(hours, 2);
}; // this will get the current moment of time and another dayjs object reprensenting the end of countDown

const getRemainingDays = (nowDayjs, timeStampDayjs) => {
  const days = timeStampDayjs.diff(nowDayjs, 'days');
  return days.toString();
}; // this will get the current moment of time and another dayjs object reprensenting the end of countDown

const padWithZeros = (number, minLength) => {
  const numberString = number.toString();
  if (numberString.length >= minLength) {
    return numberString;
  }

  return '0'.repeat(minLength - numberString.length) + numberString;
}; // it receives the number we want to patch and also receives the min length that hte string should have.
